import app from 'app';
import wishlistPage from './wishlist-page/main';

app.add({
  wishlistPage,
});
app.mount();
